import { styled } from "../../theme";
import { ClearFieldButton } from "../atoms/clear-field-button";
export const ClearButton = styled(ClearFieldButton) `
  position: absolute;
  bottom: 45%;
  right: 1px;
  padding: 2px;
  cursor: pointer;
`;
export const TextAreaWrapper = styled.div `
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  position: relative;
  margin-top: 8px;

  textarea {
    padding-right: 1.2em;
  }
`;
